// Leitores dos valores tal como saem de um IFC lido em STEP.
//
// Um valor pode vir cru ou embrulhado em `{ value, type }`, e os ângulos
// geográficos vêm como IfcCompoundPlaneAngleMeasure, uma lista de graus,
// minutos, segundos e milionésimos de segundo. Estas funções são o
// tratamento comum, para nenhum consumidor ter de o repetir.

/** Desembrulha `{ value }` quando existe. */
export function val(x: unknown): unknown {
  if (x && typeof x === 'object' && 'value' in (x as Record<string, unknown>)) {
    return (x as Record<string, unknown>).value
  }
  return x
}

/** Texto não vazio, ou null. */
export function str(x: unknown): string | null {
  const v = val(x)
  if (v === null || v === undefined) return null
  const s = String(v).trim()
  return s.length > 0 ? s : null
}

/** Número finito, ou null. */
export function num(x: unknown): number | null {
  const v = val(x)
  if (v === null || v === undefined || v === '') return null
  const n = Number(v)
  return Number.isFinite(n) ? n : null
}

/** IfcCompoundPlaneAngleMeasure -> graus decimais.
 *
 *  O sinal está no primeiro elemento e vale para todos: -9 graus 8
 *  minutos é -9,133..., não -9 + 8/60. Tratar cada parte com o seu
 *  próprio sinal daria um erro de vários quilómetros em longitudes
 *  negativas, que é o caso de Portugal. */
export function dms(x: unknown): number | null {
  const v = val(x)
  if (!Array.isArray(v) || v.length === 0) return null
  const parts = v.map((p) => num(p) ?? 0)
  const sign = parts[0] < 0 ? -1 : 1
  const deg = Math.abs(parts[0])
  const min = Math.abs(parts[1] ?? 0)
  const sec = Math.abs(parts[2] ?? 0)
  const micro = Math.abs(parts[3] ?? 0)
  return sign * (deg + min / 60 + (sec + micro / 1e6) / 3600)
}

export function round(n: number, digits: number): number {
  const f = 10 ** digits
  return Math.round(n * f) / f
}
